// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputPriceForm_inputContainer__V0fOU"};